import React from 'react';
import { Link } from 'react-router-dom';
import { Droplets, Facebook, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';
import { mockData } from '../mock';

const XIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-sky-50 to-emerald-50 border-t border-sky-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="bg-gradient-to-r from-sky-400 to-emerald-400 p-2 rounded-lg">
                <Droplets className="h-6 w-6 text-white" />
              </div>
              <span className="text-xl font-bold bg-gradient-to-r from-sky-600 to-emerald-600 bg-clip-text text-transparent">
                Eau Gratuite
              </span>
            </div>
            <p className="text-gray-600 mb-6 max-w-md">
              L'eau gratuite financée par la publicité. Chaque bouteille contribue à construire 
              des puits d'eau avec l'Association Ulker's pour un monde plus solidaire.
            </p>
            <div className="flex space-x-4">
              {[
                { platform: 'Facebook', icon: Facebook, url: 'https://facebook.com/eau.gratuite' },
                { platform: 'X', icon: XIcon, url: 'https://x.com/eau_gratuite' },
                { platform: 'Instagram', icon: Instagram, url: 'https://www.instagram.com/eaugratuite.io/' },
                { platform: 'LinkedIn', icon: Linkedin, url: 'https://linkedin.com/company/eau-gratuite' }
              ].map((social) => {
                const IconComponent = social.icon;
                
                return (
                  <a
                    key={social.platform}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 bg-white rounded-lg flex items-center justify-center text-gray-600 hover:text-sky-600 hover:bg-sky-50 transition-all duration-200 shadow-sm hover:shadow-md"
                  >
                    <IconComponent className="h-5 w-5" />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Navigation Links */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Navigation</h3>
            <ul className="space-y-3">
              {mockData.navigation.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-gray-600 hover:text-sky-600 transition-colors duration-200"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Contact</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3 text-gray-600">
                <Mail className="h-5 w-5 text-sky-500" />
                <span>{mockData.contact.email}</span>
              </div>
              <div className="flex items-center space-x-3 text-gray-600">
                <Phone className="h-5 w-5 text-sky-500" />
                <span>{mockData.contact.phone}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-sky-200 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-600 text-sm">
            © {currentYear} Eau Gratuite. Tous droits réservés.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/politique-confidentialite" className="text-gray-600 hover:text-sky-600 text-sm transition-colors duration-200">
              Politique de confidentialité
            </Link>
            <Link to="/conditions-utilisation" className="text-gray-600 hover:text-sky-600 text-sm transition-colors duration-200">
              Conditions d'utilisation
            </Link>
            <Link to="/mentions-legales" className="text-gray-600 hover:text-sky-600 text-sm transition-colors duration-200">
              Mentions légales
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;